module.exports = __webpack_public_path__ + "static/media/billing-apps-img-1.341f1e5c.png";